export default __webpack_public_path__ + "static/media/dineIm1.8a9b5c50.png";